import { Assets } from "../Assets";
import { Carryable } from "../components/Carryable";
import { Cookable } from "../components/Cookable";
import { LevelObject } from "../LevelObject";
export class Skewer extends Cookable(Carryable(LevelObject)) {
    constructor(levelMap, position) {
        super(levelMap, Assets.objects.RawSkewer.clone(), position);
        this.cookTime = 5;
        this.burnTime = 20;
    }
    static get type() {
        return 'skewer';
    }
    onCooked() {
        this.model = Assets.objects.CookedSkewer.clone();
    }
    onBurnt() {
        this.model = Assets.objects.BurntSkewer.clone();
    }
}
